import { render, staticRenderFns } from "./RegisterAssetsInfoPane.vue?vue&type=template&id=19b36e07&scoped=true&"
import script from "./RegisterAssetsInfoPane.vue?vue&type=script&lang=js&"
export * from "./RegisterAssetsInfoPane.vue?vue&type=script&lang=js&"
import style0 from "./RegisterAssetsInfoPane.vue?vue&type=style&index=0&id=19b36e07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b36e07",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VRow})
